export default {
  thumbnail: {
    borderRadius: 10,
    width: 50,
    height: 50,
    objectFit: 'cover',
    margin: 5
  },
  modalwrapper: {
    objectFit: 'cover'
  },
  modalimage: {
    maxHeight: '90vh',
    maxWidht: '90vh'
  }
};
